import { NavLink } from "react-router-dom";
import { ItemTypes } from "./constants";
import { useDrag, useDrop } from "react-dnd";
import FilmanizeCheckbox from "../../../../shared/filmanize-checkbox";

function Costume(props) {
  const {
    costume,
    aliasCostume,
    unaliasCostume,
    readOnly,
    filmId,
    processingCostumeIds = [],
    isSelected,
    onToggleSelect
  } = props;
  const scriptDaysString = costume.scriptDays?.join(', ');

  const hasAliases = (costume.aliases || []).length > 0;
  const isProcessing = processingCostumeIds.includes(costume.id);

  const propDropped = (alias) => {
    aliasCostume(filmId, alias, costume);
  };

  const canDropProp = (item, monitor) => {
    const itemIsProcessing = processingCostumeIds.includes(item.costume.id);
    return !readOnly && !isProcessing && !itemIsProcessing && item.costume.id != costume.id;
  };

  const canDragProp = (monitor) => {
    return !readOnly && !hasAliases && !isProcessing;
  };

  const [{ isOverProp }, dropProp] = useDrop({
    accept: ItemTypes.COSTUME,
    drop: (item: any, monitor) => propDropped(item.costume),
    canDrop: (item, monitor) => canDropProp(item, monitor),
    collect: (monitor) => ({
      isOverProp: !!monitor.isOver()
    })
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.COSTUME, costume },
    canDrag: (monitor) => canDragProp(monitor),
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging()
    })
  });

  const getItemStyle = (isDragging) => ({
    background: isDragging ? "#947eed" : "#040f21"
  });

  return (
    <>
      <tr ref={drag}
        style={{
          cursor: !hasAliases && !readOnly && !isProcessing ? "grab" : "",
          opacity: isProcessing ? 0.5 : 1
        }}>
        {!readOnly && (
          <td>
            <FilmanizeCheckbox
              checked={isSelected}
              onChange={onToggleSelect}
            />
          </td>
        )}
        <td ref={dropProp} style={getItemStyle(isOverProp)}>
          {!readOnly && !hasAliases && !isProcessing && (
            <i className="material-icons dark">drag_indicator</i>
          )}
          <NavLink to={`/films/${filmId}/costumes/${costume.id}/edit`}>
            {costume.name}
          </NavLink>
        </td>
        <td>
          {scriptDaysString}
        </td>
        <td>
          {costume.acquisitionMethodDescription}
        </td>
        <td>
          {costume.acquired ? "Yes" : "No"}
        </td>
      </tr>
      {(costume.aliases || []).map((alias) => {
        const aliasIsProcessing = processingCostumeIds.includes(alias.id);
        return (
          <tr key={alias.id} style={{ opacity: aliasIsProcessing ? 0.5 : 1 }}>
            {!readOnly && <td></td>}
            <td colSpan={4}>
              <div style={{ marginLeft: 30 }}>
                {alias.name}
                &nbsp;
                {!readOnly && !aliasIsProcessing && !isProcessing && (
                  <a onClick={() => unaliasCostume(filmId, alias, costume)}>
                    <i className="material-icons">cancel</i>
                  </a>
                )}
              </div>
            </td>
          </tr>
        );
      })}
    </>
  );
}

export default Costume;
